import React, { FunctionComponent, useMemo } from 'react';

import { setHtml } from 'Modules/ui';
import { Typography, TypographyProps } from 'Modules/ui3';

import { WithContentSize } from '../types';


/*
    BLOCK: header
    PARAMS: text: string, level: number [1-6]
    EXAMPLE:
    {
      "type": "header",
      "data": {
         "text": "Why Telegram is the best messenger",
         "level": 2
       }
    }
 */

type HeaderRenderProps = WithContentSize & {
    text: string;
    level: number;
};

const fontSize = {
    h1: {
        desktop: '39px',
        mobile: '20px',
    },
    h2: {
        desktop: '31px',
        mobile: '18px',
    },
    h3: {
        desktop: '20px',
        mobile: '16px',
    },
    h6: {
        desktop: '18px',
        mobile: '14px',
    },
};
const lineHeigh = {
    desktop: '1.25',
    mobile: '1.4',
};
const marginY = {
    desktop: '24px',
    mobile: '16px',
};

const getComponent = (level: HeaderRenderProps['level']) => {
    switch (level) {
        case 1: return 'h1';
        case 2: return 'h2';
        case 3: return 'h3';
        default: return 'h6';
    }
};

export const HeaderRenderer: FunctionComponent<HeaderRenderProps> = ({
    text,
    level,
    size,
}) => {
    const typographyProps = useMemo<TypographyProps>(() => {
        const component = getComponent(level);
        return {
            component,
            lineHeight: lineHeigh[size],
            my: marginY[size],
            fontSize: fontSize[component][size],
        };
    }, [level, size]);
    return (
        <Typography
            fontWeight='500'
            color='grayscale.shade95'
            {...typographyProps}
            {...setHtml(text)}
        />
    );
};
